import { gql } from '@apollo/client';
import type { UserActionPermissionCheck_UserFragment } from '../graphql/generated/graphqlTypes';

export const EDIT_PROFILE = 'EDIT_PROFILE';
export const DEACTIVATE = 'DEACTIVATE';
export const RESTORE_DEACTIVATED = 'RESTORE_DEACTIVATED';
export const TRANSFER_POST_OWNERSHIP = 'TRANSFER_POST_OWNERSHIP';
export const DOWNGRADE_TO_GUEST = 'DOWNGRADE_TO_GUEST';
export const UPGRADE_TO_USER = 'UPGRADE_TO_USER';
export const DEMOTE_TO_USER = 'DEMOTE_TO_USER';
export const PROMOTE_TO_ADMIN = 'PROMOTE_TO_ADMIN';

const USER_FRAGMENT = gql`
  fragment userActionPermissionCheck_user on User {
    id
    type
    deactivatedAt
  }
`;

function userActionPermissionCheck(
  action: string,
  user: UserActionPermissionCheck_UserFragment,
  currentUser: UserActionPermissionCheck_UserFragment,
) {
  if (action === EDIT_PROFILE && user.id === currentUser.id) return true;

  if (currentUser.type !== 'ADMIN') return false;

  if (user.deactivatedAt) {
    return [RESTORE_DEACTIVATED, TRANSFER_POST_OWNERSHIP].includes(action);
  }

  switch (action) {
    case EDIT_PROFILE:
    case DEACTIVATE:
      return user.type !== 'BOT';
    case DOWNGRADE_TO_GUEST:
      return user.type === 'USER';
    case UPGRADE_TO_USER:
      return user.type === 'GUEST';
    case DEMOTE_TO_USER:
      return user.type === 'ADMIN';
    case PROMOTE_TO_ADMIN:
      return user.type === 'USER';
    default:
      return false;
  }
}

userActionPermissionCheck.fragments = {
  user: USER_FRAGMENT,
};

export default userActionPermissionCheck;
